'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The handler template.
 * 
 * @export
 * @class DemoRestHandler
 */
var DemoRestHandler = function () {
    /**
     * Creates an instance of DemoRestHandler.
     * 
     * @param {Plugin} plugin 
     * @memberof DemoRestHandler
     */
    function DemoRestHandler(plugin) {
        (0, _classCallCheck3.default)(this, DemoRestHandler);

        this.plugin = plugin;

        this.handle = this.handle.bind(this);
    }

    /**
     * Handle a REST request: http://locahost:3000/demoPlugin/demo/info
     * 
     * @param {Request} request 
     * @param {Response} response 
     * @memberof DemoRestHandler
     */


    (0, _createClass3.default)(DemoRestHandler, [{
        key: 'handle',
        value: function handle(request, response) {
            response.json({ "demo": "Demo Rest Handler." });
        }
    }]);
    return DemoRestHandler;
}();

exports.default = DemoRestHandler;
//# sourceMappingURL=DemoRestHandler.js.map